import { render, staticRenderFns } from "./robotSetup.vue?vue&type=template&id=691f8284&scoped=true&"
import script from "./robotSetup.vue?vue&type=script&lang=js&"
export * from "./robotSetup.vue?vue&type=script&lang=js&"
import style0 from "./robotSetup.vue?vue&type=style&index=0&id=691f8284&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691f8284",
  null
  
)

export default component.exports